/**
 * NavigationListItem Component
 *
 * Specialized ListItemButton for navigation menus.
 * Encapsulates navigation-specific selection and hover states.
 */

import { ListItemButton, ListItemButtonProps } from '@mui/material';
import React from 'react';

// Allow any additional props for component polymorphism (e.g., component={Link} to="/path")
interface NavigationListItemProps extends ListItemButtonProps {
  [key: string]: any;
}

const NavigationListItem = React.forwardRef<HTMLDivElement, NavigationListItemProps>(({ sx, ...props }, ref) => {
  return (
    <ListItemButton
      ref={ref}
      sx={{
        '&.Mui-selected': {
          bgcolor: 'rgb(226, 226, 226)',
        },
        '&:hover': {
          bgcolor: 'rgb(240, 240, 240)',
        },
        '&.Mui-selected:hover': {
          bgcolor: 'rgb(226, 226, 226)',
        },
        ...sx,
      }}
      {...props}
    />
  );
});

NavigationListItem.displayName = 'NavigationListItem';

export default NavigationListItem;
